import store from "@/store";

export default function auth({ next, router }) {
  if (!store.getters["base/isAuthenticated"]) {
    return router.push("/login");
  }
  return next();
}
